import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import axios from 'axios';

// Use backend URL from environment
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Check for session_id in URL fragment
    const hash = location.hash;
    if (hash.includes('session_id=')) {
      processSessionId(hash);
    }
  }, [isAuthenticated, location.hash]);

  const processSessionId = async (hash) => {
    setLoading(true);
    try {
      const sessionId = hash.split('session_id=')[1].split('&')[0];
      console.log('=== AUTH DEBUG ===');
      console.log('Full hash:', hash);
      console.log('Extracted session_id:', sessionId);
      console.log('Session ID length:', sessionId?.length);
      console.log('Backend URL:', BACKEND_URL);
      
      // Call backend to process session
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/session`,
        {},
        {
          headers: {
            'X-Session-ID': sessionId
          },
          withCredentials: true
        }
      );

      console.log('Auth successful!', response.data);
      const { user } = response.data;
      
      // Update auth context
      login(user, user.isAdmin);
      
      // Clean URL and navigate
      window.history.replaceState({}, document.title, '/');
      
      // Small delay to ensure state updates
      setTimeout(() => {
        navigate('/');
      }, 100);
    } catch (error) {
      console.error('=== AUTH ERROR ===');
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);
      alert('Login failed. Please try again.');
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // 1. Use your Client ID from Google Cloud Console
    const CLIENT_ID = "520100089028-jf80gnif475qs6oa5liljto52cvtaq0h.apps.googleusercontent.com";
    
    // 2. This dynamic URI ensures that if the user is on www. or non-www, it matches
    const REDIRECT_URI = window.location.origin + '/login';
    
    const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
      `response_type=code&` +
      `scope=openid%20email%20profile&` +
      `access_type=offline&` +
      `prompt=select_account`;

    window.location.href = googleAuthUrl;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 to-red-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Logo and Header */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_selected-repo/artifacts/x30z79ye_IMG_1165.PNG" 
                alt="Arihant Milk Products" 
                className="h-20 w-auto"
              />
            </div>
            <h1 className="text-3xl font-bold text-rose-900 mb-2">Welcome to Arihant Milk Products</h1>
            <p className="text-gray-600">Sign in with your Google account</p>
          </div>

          {/* Google Login Button */}
          <div className="space-y-4">
            <Button
              onClick={handleGoogleLogin}
              className="w-full bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 py-6 text-lg font-medium flex items-center justify-center space-x-3"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              <span>Continue with Google</span>
            </Button>
          </div>

          <p className="text-center text-sm text-gray-500 mt-8">
            By continuing, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
